import { REDUX_STORE } from '@funnels/constants';
import {
  CustomerData,
  PersistApplicationDataCollectionAction,
  PersistApplicationDataCollectionFailedAction,
  PersistApplicationDataCollectionSuccessAction,
} from '@funnels/types';
import { buildTracking } from '@funnels/utils';

export function persistApplicationDataCollection(
  formData: any,
  isTeamview: boolean,
  customerData: CustomerData,
  tracking: ReturnType<typeof buildTracking>,
  isClone?: boolean,
  isHydrated?: boolean
): PersistApplicationDataCollectionAction {
  return {
    type: REDUX_STORE.APPLICATION_DATA_COLLECTION.ACTION_TYPES.PERSIST_APPLICATION_DATA_COLLECTION,
    formData,
    isTeamview,
    customerData,
    tracking,
    isClone,
    isHydrated,
  };
}

export function persistApplicationDataCollectionSuccess(): PersistApplicationDataCollectionSuccessAction {
  return { type: REDUX_STORE.APPLICATION_DATA_COLLECTION.ACTION_TYPES.PERSIST_APPLICATION_DATA_COLLECTION_SUCCESS };
}

export function persistApplicationDataCollectionFailed(error: any): PersistApplicationDataCollectionFailedAction {
  return {
    type: REDUX_STORE.APPLICATION_DATA_COLLECTION.ACTION_TYPES.PERSIST_APPLICATION_DATA_COLLECTION_FAILED,
    error,
  };
}
